import { BrowserModule }         from '@angular/platform-browser';
import { NgModule }              from '@angular/core';
import { HttpModule, Http }      from '@angular/http';
import { TranslateService,
         TranslateModule,
         TranslateLoader,
         TranslateStaticLoader } from 'ng2-translate/ng2-translate'; 
import { Ng2UiAuthModule,
         CustomConfig }          from 'ng2-ui-auth';

import { AppComponent }          from './app.component';

import { CoreModule }            from './core/core.module';
import { LayoutModule }          from './layout/layout.module';
import { SharedModule }          from './shared/shared.module';
import { RoutesModule }          from './routes/routes.module';
import { ServicesModule }        from './services/services.module';

import Config                    from './services/configuracion/config';

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: Http) {
    return new TranslateStaticLoader(http, './assets/i18n', '.json');
}

export class MyAuthConfig extends CustomConfig {
  loginUrl       = [Config.ApiUrl, 'usuario/login'].join('/');
  signupUrl      = [Config.ApiUrl, 'usuario/signup'].join('/');
  defaultHeaders = {'Content-Type': 'application/json'};
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        CoreModule,
        LayoutModule,
        SharedModule.forRoot(),
        RoutesModule,
        ServicesModule,
        Ng2UiAuthModule.forRoot(MyAuthConfig),
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [Http]
        })
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts